export const LOGIN_CUSTOM_PARAMS = 'LOGIN_CUSTOM_PARAMS'
export const SET_PARAM_FACTORY = 'SET_PARAM_FACTORY'
